<template>
    <v-dialog v-model="show.openDialog" width="auto" persistent>
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ show.title }}</span>
            </v-card-title>
            <v-card-text>
                <div class="text-center">
                    <img src="@/assets/images/warning.png">
                </div>
                <div class="description-text">
                    <p>{{ show.description }}</p>
                </div>
            </v-card-text>
            <v-card-actions class="actions-buttons">
                <v-btn @click="show.openDialog = false">Cerrar</v-btn>
                <v-btn @click="show.openDialog = false">Aceptar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'AlertComponent',
        props: {
            value: {
                openDialog: Boolean,
                title: String,
                description: String,
            }
        },
        data: () => ({
        }),
        computed: {
            show: {
                get () {
                    return this.value
                },
                set (value) {
                    this.$emit('input', value)
                }
            }
        }
    }
    
</script>
<style scoped>
    img {
        height: 230px;
        width: auto;
        padding: 40px;
    }

    .description-text {
        display: flex;
        justify-content: center;
    }

    .description-text p {
        width: 90%;
        text-align: center;
    }
    
    .actions-buttons {
        display: flex;
        justify-content: flex-end;
    }
</style>